import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiRepository } from '../repositories/base-api-repository';

export interface ProductFruitsHmac {
  hash: string;
  expiration: string;
}

@Injectable({
  providedIn: 'root',
})
export class ProductFruitsService extends BaseApiRepository {
  constructor() {
    super();
  }

  getHmac(): Observable<ProductFruitsHmac> {
    return this.sendGetRequest<ProductFruitsHmac>('/productfruits/hmac');
  }
}
